import { SET_NOTICE, CLEAR_NOTICE } from "actions/notifications";

const initialState = { notice: "" };

export default function notifications(state = initialState, action) {
  switch (action.type) {
    case SET_NOTICE:
      return { ...state, notice: action.notice };
    case CLEAR_NOTICE:
      return { ...state, notice: "" };
    default:
      return state;
  }
}
